<footer>
  <div class="lfoot">
    <div class="lfd wb">
      Screening Implementation for Bank Alfalah by LFD<br />
      Copyright © {{ copyRightYear }} LFD Private Limited. All Rights Reserved
    </div>
  </div>
</footer>